import { Snackbar } from '@mui/material';
import { createContext, useCallback, useContext, useState } from 'react';
import { Alert } from '@/components/muiComponents';

export interface ToastProps {
  message: string;
  severity: 'error' | 'info' | 'success' | 'warning';
  positionVertical?: 'top' | 'bottom';
  positionHorizontal?: 'left' | 'right' | 'center';
}
type ShowToastType = (props: ToastProps) => void;

type ToastContextType = {
  showToast: ShowToastType;
  setToastTheme: (comp: any) => void;
};
const ToastContext = createContext<ToastContextType>({
  showToast: () => {},
  setToastTheme: () => {},
});

const ToastContextProvider = ({ children }: { children: any }) => {
  const [globalSnackbar, setGlobalSnackbar] = useState<{
    open: boolean;
    props?: ToastProps;
  }>({ open: false });
  const [toastTheme, setToastTheme] = useState<any>({});
  const closeSnackbar = (): void => setGlobalSnackbar({ open: false });

  const showToast = useCallback((props: ToastProps) => {
    setGlobalSnackbar({ open: true, props });
  }, []);

  const setToastThemeToken = useCallback((comp: any) => {
    setToastTheme(comp);
  }, []);

  const Toast = () => (
    <Snackbar
      open={globalSnackbar.open}
      onClose={closeSnackbar}
      autoHideDuration={3000}
      anchorOrigin={{
        vertical: globalSnackbar?.props?.positionVertical || 'top',
        horizontal: globalSnackbar?.props?.positionHorizontal || 'right',
      }}
    >
      <div>
        <Alert
          severity={globalSnackbar?.props?.severity || 'info'}
          comp={toastTheme}
        >
          {globalSnackbar?.props?.message || ''}
        </Alert>
      </div>
    </Snackbar>
  );

  return (
    <ToastContext.Provider
      value={{ showToast, setToastTheme: setToastThemeToken }}
    >
      {children}
      <Toast />
    </ToastContext.Provider>
  );
};

const useGlobalToast = () => useContext(ToastContext);

export { ToastContextProvider, useGlobalToast };

export default ToastContextProvider;
